import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import Swatch from '../swatch';
import { getGradientFromCSSColors } from './utils';

function DuotoneSwatch(_ref) {
  let {
    values
  } = _ref;
  return createElement(Swatch, {
    fill: values && getGradientFromCSSColors(values, '135deg')
  });
}

export default DuotoneSwatch;
//# sourceMappingURL=duotone-swatch.js.map